module.exports = __webpack_public_path__ + "./docs/img/voxengine.795bb3321a3601af0ba4c71b3782d1d2.svg";